"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAssignAssessmentDto = instanceOfAssignAssessmentDto;
exports.AssignAssessmentDtoFromJSON = AssignAssessmentDtoFromJSON;
exports.AssignAssessmentDtoFromJSONTyped = AssignAssessmentDtoFromJSONTyped;
exports.AssignAssessmentDtoToJSON = AssignAssessmentDtoToJSON;
exports.AssignAssessmentDtoToJSONTyped = AssignAssessmentDtoToJSONTyped;
/**
 * Check if a given object implements the AssignAssessmentDto interface.
 */
function instanceOfAssignAssessmentDto(value) {
    if (!('assessmentIds' in value) || value['assessmentIds'] === undefined)
        return false;
    return true;
}
function AssignAssessmentDtoFromJSON(json) {
    return AssignAssessmentDtoFromJSONTyped(json, false);
}
function AssignAssessmentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'assessmentIds': json['assessmentIds'],
    };
}
function AssignAssessmentDtoToJSON(json) {
    return AssignAssessmentDtoToJSONTyped(json, false);
}
function AssignAssessmentDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'assessmentIds': value['assessmentIds'],
    };
}
//# sourceMappingURL=AssignAssessmentDto.js.map